import { render, staticRenderFns } from "./social-bonus-form.vue?vue&type=template&id=7c3a217e"
import script from "./social-bonus-form.vue?vue&type=script&lang=js"
export * from "./social-bonus-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports